import { useLanguage } from "@hooks/useLanguage";

import { getFilePreviewURL } from "@helpers/getFilePreviewURL";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

export const GetEmployeeDetails = (employee: EmployeeCommonInfoType) => {
  const { language } = useLanguage();

  const {
    nameEn,
    nameBn,
    positionName,
    positionNameBn,
    unitEn,
    unitBn,
    documentId,
    fileId,
    image,
  } = employee || {};
  const { documentId: ImageDocId, fileId: imageFileId } = image || {};

  const employeeName = language === "bn" ? nameBn : nameEn;
  const employeeDesignation = language === "bn" ? positionNameBn : positionName;
  const employeeUnit = language === "bn" ? unitBn : unitEn;
  const employeePosition = `${
    employeeDesignation !== null ? employeeDesignation : ""
  } ${employeeUnit !== null ? `(${employeeUnit})` : ""}`;
  const employeeImage =
    fileId && documentId
      ? getFilePreviewURL(documentId as any, fileId as any)
      : image
      ? getFilePreviewURL(ImageDocId as any, imageFileId as any)
      : undefined;

  return {
    employeeName,
    employeePosition,
    employeeDesignation,
    employeeUnit,
    employeeImage,
  };
};
